import React from 'react';

const AutocompleteInput = ({ ingredients, value, onChange }) => {
  return (
    <>
    <input
  list="ingredient-list"
  value={value}
  onInput={(e) => onChange(e.target.value)} // Use onInput instead
  placeholder="Type ingredient..."
/>

      <datalist id="ingredient-list">
        {ingredients.map((i) => (
          <option key={i.name} value={i.name} />
        ))}
      </datalist>
    </>
  );
};

export default AutocompleteInput;
